// กล่องเลือกวิธีชำระเงิน — ใช้ร่วมกันในหน้าชำระเงิน (CartCheckout) และหน้าสมัครคอร์ส (EnrollCourse)
// มีตัวเลือกเดียว (ชำระเงินออนไลน์) เลือกอยู่เสมอ: กดชำระเงินแล้วระบบพาไปหน้าของผู้ให้บริการ (Payso) แล้วเลือกช่องทางที่นั่น
export default function PaymentMethodPicker() {
  return (
    <div className="space-y-3">
      <label className="flex cursor-default items-start gap-4 rounded-sm border-2 border-indigo-400 bg-indigo-500/10 p-4">
        <input type="radio" name="payment" checked readOnly className="mt-1 accent-indigo-500" />
        <div>
          <p className="font-medium text-text">ชำระเงินออนไลน์</p>
          <p className="mt-1 text-sm text-text-muted">บัตร, QR พร้อมเพย์, วอลเล็ต, โมบายแบงก์กิ้ง — เลือกวิธีที่สะดวกในขั้นตอนถัดไป</p>
          <div className="mt-2 flex items-center gap-2">
            <div className="inline-flex items-center gap-1.5 rounded border border-accent/30 bg-white px-2 py-1">
              <span className="h-3.5 w-3.5 -skew-x-12 rounded-[3px] bg-gradient-to-br from-blue-600 to-rose-500" />
              <span className="text-xs font-extrabold italic text-blue-700">payso</span>
            </div>
            <span className="text-xs text-text-muted">ชำระเงินผ่าน Payso</span>
          </div>
        </div>
      </label>
    </div>
  )
}
